import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <p className="footer-text">
            Desenvolvido com carinho por
            <a 
              href="https://www.cidadania4u.com.br/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
            >
              <img 
                src="https://www.cidadania4u.com.br/wp-content/uploads/2025/04/Ativo-1-2.svg" 
                alt="Cidadania4u Logo" 
                className="footer-logo"
                width="20"
                height="20"
              />
              Cidadania4u
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
